module.exports = __webpack_public_path__ + "media/images/Divorcee-Matrimony-Banner1-9de59e67dd591b8f1637963b455ca314.jpg";